import { render } from "./TextBot.vue?vue&type=template&id=5706752c&ts=true"
import script from "./TextBot.vue?vue&type=script&lang=ts"
export * from "./TextBot.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/widget.surveybot.me/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__